export type ArticleTitleConfig = {
  mode: 'auto' | 'custom';
  template: string;
};

export const ARTICLE_TITLE_VARS: { key: string; label: string; sample: string }[] = [
  { key: '{site_name}', label: '站点名', sample: '南京站' },
  { key: '{rule_name}', label: '规则名', sample: '每日汇总' },
  { key: '{count}', label: '条数', sample: '12' },
  { key: '{date}', label: '月日', sample: '8月19日' },
  { key: '{time}', label: '时分', sample: '16:58' },
  { key: '{datetime}', label: '月日时分', sample: '8月19日 16:58' },
  { key: '{ymd}', label: '年月日', sample: '2026-08-19' },
  { key: '{weekday}', label: '星期', sample: '周三' },
];

export function defaultArticleTitle(): ArticleTitleConfig {
  return {
    mode: 'auto',
    template: '{site_name} · {date}汇总',
  };
}

export function mergeArticleTitleFromApi(raw: unknown): ArticleTitleConfig {
  const d = defaultArticleTitle();
  if (!raw || typeof raw !== 'object') return d;
  const c = raw as Record<string, unknown>;
  const mode = String(c.mode || '');
  const tpl = typeof c.template === 'string' ? c.template.trim() : '';
  return {
    mode: mode === 'custom' ? 'custom' : 'auto',
    template: tpl !== '' ? tpl.slice(0, 64) : d.template,
  };
}

export function resolveArticleTitlePreview(
  cfg: ArticleTitleConfig,
  vars: { site_name: string; rule_name: string; count: string },
): string {
  const now = new Date();
  const weekdays = ['日', '一', '二', '三', '四', '五', '六'];
  const map: Record<string, string> = {
    '{site_name}': vars.site_name || '站点',
    '{rule_name}': vars.rule_name || '推送规则',
    '{count}': vars.count || '0',
    '{date}': `${now.getMonth() + 1}月${now.getDate()}日`,
    '{time}': `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`,
    '{datetime}': `${now.getMonth() + 1}月${now.getDate()}日 ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`,
    '{ymd}': `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`,
    '{weekday}': `周${weekdays[now.getDay()]}`,
  };
  let tpl =
    cfg.mode === 'custom'
      ? cfg.template || '{site_name} · {date}汇总'
      : vars.count && vars.count !== '0'
        ? '{site_name} · {date} · {count}条'
        : '{site_name} · {date}汇总';
  for (const [k, v] of Object.entries(map)) {
    tpl = tpl.split(k).join(v);
  }
  return tpl.replace(/\{[a-z_]+\}/gi, '').replace(/\s{2,}/g, ' ').trim().slice(0, 64);
}
